export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/ro.lyaml"));
at({ "ro": { "public": { "sampleString": "Exemplu de text" } } });
};